<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-address-book">
      Contacts
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.user_contacts.upload'}"
               exact>
          Upload
        </v-btn>
      </template>
    </page-title>

    <v-card class="mb-4">
      <div class="pa-4">
        <v-autocomplete v-model="form.user_id"
                        :disabled="loading"
                        label="Search for a user to see their contacts"
                        prepend-inner-icon="fal fa-search"
                        :items="activeUsers"
                        item-value="id"
                        item-text="name"
                        @change="fetchData"
                        clearable>
        </v-autocomplete>
      </div>
    </v-card>
    <v-card v-if="loading || loaded">
      <div class="pa-4">
        <admin-user-contacts-table :contacts="contacts"
                                   :loading="loading"
                                   @updated="fetchData">
        </admin-user-contacts-table>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import userContactService from '../../services/userContactService';
import UserContactsTable from './components/UserContactsTable';
import AdminUserContactsToolbar from './components/AdminUserContactsToolbar';
import AdminUserContactsTable from './components/AdminUserContactsTable';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, AdminUserContactsTable, AdminUserContactsToolbar, UserContactsTable},
  data() {
    return {
      contacts: [],
      form: new Form({
        user_id: '',
      }),
      loaded: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    isAdminRoute() {
      return this.$route.name === 'admin.user_contacts.index';
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.form.user_id) {
        this.contacts = [];
        this.loaded = false;
        return;
      }
      this.loading = true;
      const form = {
        user_id: this.form.user_id,
      };
      userContactService.getContacts(form)
        .then(data => {
          this.contacts = data;
        })
        .finally(() => {
          this.loading = false;
          this.loaded = true;
        })
    },
  }
}
</script>
